export enum Language {
    NL = "Dutch",
    FR = "French",
    DE = "German",
    EN = "English"
}
